import React, { useState, createContext, useEffect, } from "react";
import { useStrapiObjectClass } from "./Hooks";
import { set } from "lodash";
export const GlobalStates = createContext();

const TaskContextProvider = (props) => {
    const [tasks, setTasks] = useState('login');
    const [user, setUser] = useState('');
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(true)
    const [type, setType] = useState('')
    const [r, setR] = useState(0)
    const [alert, setAlert] = useState('')
    const [languageG, setLanguageG] = useState('')
    // const [path, setPath] = useState('http://localhost:1337/api/')//local`
    // const [pathImg, setPathImg] = useState('http://localhost:1337')//local for img
    const [path, setPath] = useState('https://vh-ol6h.onrender.com/api/')//global
    const [pathImg, setPathImg] = useState('https://vh-ol6h.onrender.com/')//global for img

    const [gyvunai,setGyvunai] = useState([])
    const [savininkai,setSavininkai]=useState([])
    // const {getAll:getSeimininkai}=useStrapiObjectClass({name:'seimininkai',})
    // const { getAll: getAllAnimal } = useStrapiObjectClass({
    //     name: 'Gyvunai',
    //     extraFilter:  ''
    // });
    useEffect(()=>{
        if(user&& user.length>0&& token.length>0&&path){
        // getAllAnimal()
        }
    },[user])


    return (
        <GlobalStates.Provider value={{
            tasks, setTasks,
            user, setUser,
            token, setToken,
            path, setPath,
            pathImg, setPathImg,
            isLoading, setIsLoading,
            type, setType,
            alert, setAlert,
            r, setR,
            languageG, setLanguageG,
            gyvunai,setGyvunai,savininkai,setSavininkai
        }}>
            {props.children}
        </GlobalStates.Provider>
    );
};

export default TaskContextProvider

